import { ResponseV2 } from "@/types/responseV2";
import { apiClientV2 } from "./apiClientV2";
import { UserV2Payload, UserV2 } from "@/types";

const getUsersV2 = () =>
  apiClientV2.get<ResponseV2<UserV2[]>, ResponseV2<UserV2[]>>("/users");
const getMeV2 = () =>
  apiClientV2.get<ResponseV2<UserV2>, ResponseV2<UserV2>>(`/users/me`);
const getUserV2 = (userId: number) =>
  apiClientV2.get<ResponseV2<UserV2>, ResponseV2<UserV2>>(`/users/${userId}`);

const postUserV2 = (payload: UserV2Payload) =>
  apiClientV2.post<ResponseV2<UserV2>, ResponseV2<UserV2>>("/users", payload);

const patchUserV2 = (userId: number, payload: Partial<UserV2Payload>) =>
  apiClientV2.post<ResponseV2<UserV2>, ResponseV2<UserV2>>(
    `/users/${userId}`,
    payload
  );

export const users = {
  getAll: getUsersV2,
  get: getUserV2,
  getMe: getMeV2,
  post: postUserV2,
  patch: patchUserV2,
};
